import React, { useEffect, useState, Component } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { Switch, Route, Redirect, useLocation, useHistory } from 'react-router-dom';
import { Button } from '../_atoms';
import { sendOrder, checkOrder, takeLink, getDelivery } from '../redux/actions/basket';
import { setBasket } from '../redux/reducers/basketReducer';
import { clearError } from '../redux/reducers/commonReducer';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import messages from '../constants/messages';
import { LoaderSpinner } from '../components/loaderAndSpinners';
import { MainElemRender } from './MainElemRender';
import Basket from './BASKET';
import { ROUTES } from '../constants';
import { Certificates } from './Certificates';
import { UserAgreement } from '../components/user_agreement';
import { UserData } from '../components/user_data';
import collectProductVariants from '../helpers/collectProductVariants';
import { getProductPayStatus, getProducts } from '../redux/actions/common';
import { PRODUCT_PAGES } from '../constants/routes';
import '../styles/main_photo_page.scss';
import { RedirectPage } from './Redirect';

export const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [loader, setLoader] = useState({
    showLoader: false,
    showAnswer: '',
    link: '',
    showLineLoader: false,
    loader: 0,
    extraItem: false,
  });

  const basket = useSelector(state => state.basket.basket);

  useEffect(() => {
    const order_id = localStorage.getItem('order_id');

    dispatch(getProducts());
    dispatch(getDelivery());
    dispatch(clearError());
    if (order_id) dispatch(getProductPayStatus(order_id));
  }, []);

  useEffect(() => {
    setLoader({
      showAnswer: '',
      showLoader: false,
      showLineLoader: false,
      loader: 0,
      link: '',
      extraItem: false,
    });
  }, [location.pathname]);

  const payFunction = async userInfo => {
    setLoader(l => ({ ...l, showLoader: true, showLineLoader: true }));
    const { product_variants, comments, hashImageMass, accomp_products } = collectProductVariants(basket, true);
    // here we sort out the same images
    const hashImageLength = hashImageMass.length;
    const clearHashImage = [];
    for (let q = 0; q < hashImageLength; q += 1) {
      if (
        !clearHashImage.some(
          imgElem =>
            imgElem.name === hashImageMass[q].name &&
            imgElem.size === hashImageMass[q].size &&
            imgElem.lastModified === hashImageMass[q].lastModified
        )
      )
        clearHashImage.push(hashImageMass[q]);
    }

    const req = {
      shipping_type_id: userInfo.shippingType.child || userInfo.shippingType.id,
      name: userInfo.name,
      promo_code: userInfo.promoCode,
      country: userInfo.country,
      city: userInfo.city,
      street: userInfo.street,
      house: userInfo.house,
      app: userInfo.apartment,
      zip: userInfo.index,
      phone_number: userInfo.tel,
      email: userInfo.email,
      comment: comments.join('--//--//--START NEW ORDER--//--//--'),
      product_variants,
      accomp_products,
    };

    const stepLoader = 100 / 3;

    const resp = await dispatch(sendOrder(req));
    if (resp.errorMessage) {
      setLoader(l => ({ ...l, showAnswer: resp.errorMessage }));
    } else {
      setLoader(l => ({ ...l, loader: stepLoader }));
      const orderID = resp.order_id;

      const checkedOrder = await dispatch(checkOrder(orderID));
      if (checkedOrder.status) {
        setLoader(l => ({ ...l, loader: l.loader + stepLoader }));
        const link = await dispatch(takeLink(orderID));
        if (link.errorMessage) {
          setLoader(l => ({ ...l, showAnswer: link.errorMessage }));
        } else {
          setLoader(l => ({ ...l, loader: l.loader + stepLoader }));
          if (link.url) {
            localStorage.setItem('order_id', orderID);
            setLoader(l => ({ ...l, link, showAnswer: messages.linkPay, extraItem: true }));
          } else {
            setLoader(l => ({
              ...l,
              showAnswer: messages.orderAccepted,
              extra: messages.infoToMail + userInfo.email,
              closeLoader: () => {
                dispatch(setBasket([]));
                localStorage.setItem('basket', '[]');
                localStorage.removeItem('order_id');
                closeLoader();
              },
            }));
          }
        }
      } else {
        setLoader(l => ({ ...l, showAnswer: messages.orderStatusError }));
      }
    }
  };

  const closeLoader = () => {
    setLoader({
      showAnswer: '',
      showLoader: false,
      showLineLoader: false,
      loader: 0,
      link: '',
      extraItem: false,
      closeLoader: null,
    });
  };

  return (
    <BasketHandler>
      <Switch>
        <Route exact path={ROUTES.PORTAL} render={() => <Redirect to={ROUTES.FOTOBOOK} />} />
        <Route exact path={ROUTES.REDIRECT} component={RedirectPage} />
        <Route>
          <div className="main-page-photobooks">
            <LoaderSpinner
              showLoader={loader.showLoader}
              showAnswer={loader.showAnswer}
              extra={loader.extra}
              className={loader.extraItem ? 'extra-item' : ''}
              extraItem={
                loader.extraItem && (
                  <div className="loader-extra-buttons">
                    <Button onClick={() => history.push('/')}>Продолжить покупки</Button>
                    <a href={loader.link.url}>
                      <Button className="blue">Оплатить</Button>
                    </a>
                  </div>
                )
              }
              closeLoader={loader.closeLoader || closeLoader}
              showLineLoader={loader.showLineLoader}
              loader={loader.loader}
            />
            <div className="page">
              <Header />
              <div className="content">
                <Switch>
                  <Route path={ROUTES.USER_AGREEMENT} component={UserAgreement} />
                  <Route path={ROUTES.USER_DATA} component={UserData} />
                  <Route
                    path={ROUTES.PRODUCTS}
                    render={props =>
                      props.match.params.page === PRODUCT_PAGES.GIFT_CERTIFICATES ? (
                        <Certificates />
                      ) : (
                        <MainElemRender />
                      )
                    }
                  />
                  <Route
                    path={ROUTES.BASKET}
                    render={() =>
                      basket.length ? <Basket payFunction={payFunction} /> : <Redirect to={ROUTES.FOTOBOOK} />
                    }
                  />
                </Switch>
              </div>
              <Footer />
            </div>
          </div>
        </Route>
      </Switch>
    </BasketHandler>
  );
};

class BasketHandlerComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
    };
  }

  // eslint-disable-next-line react/no-deprecated
  async componentWillMount() {
    try {
      const basket = await JSON.parse(localStorage.getItem('basket'));
      if (basket?.length) await this.props.setBasket(basket);
      this.setState({ loaded: true });
    } catch {
      console.log('basket parse error');
      localStorage.setItem('basket', '[]');
      this.setState({ loaded: true });
    }
  }

  render() {
    return this.state.loaded ? this.props.children : null;
  }
}

const BasketHandler = connect(null, { setBasket })(BasketHandlerComponent);
